package one.healthium.domain.user.models

sealed interface SignInOptions {
    data class Username(
        val username: String,
        val password: String,
    ) : SignInOptions

    data class WebUser(
        val token: String,
    ) : SignInOptions

    data class MagicLink(
        val token: String,
    ) : SignInOptions
}
